export const LINKS = {
    WHATSAPP_LINK: "https://api.whatsapp.com/send/?phone=5491128080330&text&type=phone_number&app_absent=0",
    API_GALICIA: "https://172.30.150.50:30876/api",
    API_GALICIA_TEST:"https://test-webcorporativa-public.eastus.cloudapp.azure.com/api",
    URL_FORM:"https://172.30.150.50:30876/secciones/preview/test/demo2",
    ID_FORM:"E2C51578-5600-4217-B959-A9ED58C67A45",
    RECLAMOS_TERCEROS: "https://terceros.galiciaseguros.com.ar/"
}
